import React from "react";
import { a } from "kremling";
import { CpPillButton } from "@components";

type CpPillToggleProps = {
  checked?: boolean;
  className?: string;
  onChange?: (checked: boolean) => void;
  text?: string;
};

export function CpPillToggle(props: CpPillToggleProps) {
  const { checked, className, onChange, text, ...rest } = props;

  return (
    <CpPillButton
      className={a(className).m("checked", checked)}
      onClick={() => onChange?.(!checked)}
      text={text}
      {...rest}
    />
  );
}
